<template>
  <div>
    <Button @click="create" type="primary">添加班段</Button>
    <sl-table :page="false" :columns="columns" :data="segData"></sl-table>
  </div>
</template>
<script>
import segItem from './seg-item'

export default {
  components:{segItem},
  data() {
    return {
      columns: [
        {
          type: 'index',
          width: 60,
          title: '序号',
          align: 'center'
        },
        {
          title: '时段',
          key: 'shiftSegName',
          // width:150,
        },
        {
          title: '工作时段',
          key: 'worktime',
          render:(h , { row })=>{
            return h('div',row.worktime.join('-'))
          }
          // width:60,
        },
        {
          title: '休息时段',
          key: 'resttime',
          render:(h , { row })=>{
            return h('div',row.resttime.join('-'))

          }
          // width:60,
        },
        {
          title: '操作',
          render:(h, params)=>{
            return h('div', [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params)
                  }
                }
              }, '删除'),
            ])
          }
          // width:60,
        }
      ],
      segData:[],
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      modalVisible:false,
      loading:false
    }
  },

  props: {
    data: {
      type: Array , 
      default:function(){
        return []
      }
    }
  },
  watch: {
    data(val) {
      if(val){
        this.segData = data
      }
    }
  },
  methods: {
    init() {
      //let params = { search: { carId: this.carId }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
    },
    create(){
      this.$slDialog.show({
        width: 450,
        title:'新增时段',
        footerHide:true,
        // transitionNames: ['none', 'none'],
        paddingless: false,

        component:segItem,

        onOk:(a)=>{
          a.id = this.segData.length
          this.segData.push(a)
        }
      })
    },
    edit({row}){
      this.$slDialog.show({
        width: 450,
        title:'编辑时段',
        footerHide:true,
        // transitionNames: ['none', 'none'],
        paddingless: false,
        render:(h)=>{
          return h(segItem , {
            props:{
              data : {...row}
            }
          })
        },
        onOk:(a)=>{
          this.update(a.id , a)
        }
      })
    },

    update(id , data){
      let hit = this.segData[id]
      hit.shiftSegName = data.shiftSegName
      hit.worktime = data.worktime
      hit.resttime = data.resttime
    },

    remove({row}){
      let idx = this.segData.findIndex(i => i.id == row.id)
      if(idx>=0){
        this.segData.splice(idx , 1)
      }
    }
  }
}

</script>
